import { getStore } from 'core_main/store';
import { InitializePubNubParameters } from 'core_main/pubnub/types';

export const importAndInitializePubNub = (
  params?: InitializePubNubParameters,
) => {
  // eslint-disable-next-line import/no-cycle
  return import(/* webpackChunkName: "pubnub" */ '../pubnub').then((pubnub) => {
    if (!params) return pubnub;

    const { customerId, orgId, cb } = params;
    const store = getStore();

    if (!store.isPubNubConnected) {
      return pubnub
        .initializePubNub({
          customerId,
          orgId,
          cb,
        })
        .then(() => pubnub);
    }
    return pubnub;
  });
};
